import { CognitoIdentityClient } from '@aws-sdk/client-cognito-identity';
import { fromCognitoIdentityPool } from '@aws-sdk/credential-provider-cognito-identity';
import { DynamoDBClient } from '@aws-sdk/client-dynamodb';
import { DynamoDBDocument } from '@aws-sdk/lib-dynamodb';
import { S3Client } from '@aws-sdk/client-s3';

const region = process.env.REACT_APP_AWS_REGION;
const identityPoolId = process.env.REACT_APP_IDENTITY_POOL_ID;

if (!region || !identityPoolId) {
  throw new Error(
    'AWS configuration missing. Please check environment variables.',
  );
}

// Create credentials provider
const credentialsProvider = fromCognitoIdentityPool({
  client: new CognitoIdentityClient({ region }),
  identityPoolId,
});

// Create DynamoDB client
const dynamoClient = new DynamoDBClient({
  region,
  credentials: credentialsProvider,
});

// Create DynamoDB Document client for easier operations
export const dynamoDB = DynamoDBDocument.from(dynamoClient);

// Create S3 client
export const s3 = new S3Client({
  region,
  credentials: credentialsProvider,
});
